import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ApiProvider } from '../models/ApiContext';
import getIsLoggedIn from '../util/getIsLoggedIn';

const PrivateComponent = ({
	component: Component,
	authData,
	setAuthData,
	...rest
}) => {
	const navigate = useNavigate();
	const { pathname, search } = useLocation();

	const isLoggedIn = getIsLoggedIn(authData);

	useEffect(() => {
		if (!isLoggedIn && pathname !== '/sign-in') {
			navigate(`/sign-in${search}`);
		}
	}, [isLoggedIn, pathname, search]);

	return (
		<ApiProvider authData={authData} setAuthData={setAuthData}>
			<Component
				authData={authData}
				setAuthData={setAuthData}
				{...rest}
			/>
		</ApiProvider>
	);
};

export default PrivateComponent;
